import Stack from '@mui/material/Stack';
import React from 'react';
import { ProgressionListBlankRow } from '@/components/chord_progression/converter/progression_list/ProgressionListBlankRow';
import { ProgressionListChordsRow } from '@/components/chord_progression/converter/progression_list/ProgressionListChordsRow';
import { ProgressionListCommentRow } from '@/components/chord_progression/converter/progression_list/ProgressionListCommentRow';
import { Progression } from '@/components/chord_progression/converter/types';

export const ProgressionListContent = (props: {
  progressions: Progression[];
}) => (
  <Stack spacing={0}>
    {props.progressions.map((progression, index) => {
      if (progression.type === 'blank') {
        return <ProgressionListBlankRow key={index} />;
      }

      if (progression.type === 'comment') {
        return (
          <ProgressionListCommentRow
            key={index}
            comment={progression.value[0]}
          />
        );
      }

      return (
        <ProgressionListChordsRow key={index} chords={progression.value} />
      );
    })}
  </Stack>
);
